import { Controller } from "@hotwired/stimulus"

/**
 * Copy Link Controller
 * 
 * Handles copying deep links to the clipboard and showing a notification.
 */
export default class extends Controller {
  static values = {
    url: String
  }

  /**
   * Copy the URL to the clipboard and show notification
   */
  copy() {
    // Create a temporary input element
    const tempInput = document.createElement('input');
    
    // Get the full URL (including domain)
    const fullUrl = window.location.origin + this.urlValue;
    
    // Set its value to the URL
    tempInput.value = fullUrl;
    
    // Add it to the document
    document.body.appendChild(tempInput);
    
    // Select and copy
    tempInput.select();
    document.execCommand('copy');
    
    // Remove it from the document
    document.body.removeChild(tempInput);
    
    // Show notification
    const notification = document.getElementById('link-copied-notification');
    notification.classList.add('show');
    
    // Hide notification after 3 seconds
    setTimeout(() => {
      notification.classList.remove('show');
    }, 3000);
  }
}
